import {connect} from "react-redux";

const Messages_Room_Window_Default = (props) => {
    return(
        <div className="messages_room_window_default">
            <div className={`messages_room_window_default_text background_change_${props.color_background}`}>Select a chat to start messaging</div>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        color_background: state.getColorBackground.color_background
    }
}
export default connect(mapStateToProps)(Messages_Room_Window_Default);